import { useQuery } from '@tanstack/react-query';
import { fetchSeller, fetchSellers } from '../queries/sellers.queries';

export const useSellers = () =>
    useQuery({
        queryKey: ['sellers'],
        queryFn: fetchSellers,
    });

export const useSeller = (id: number | null) => {
    return useQuery({
        queryKey: ['seller', id],
        queryFn: () => {
            if (Number.isNaN(id) || id === null) return null;
            return fetchSeller(id);
        },
    });
};
